import { Subject } from 'rxjs';
import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/auth.service";
import * as i2 from "./transaction.service";
import * as i3 from "../../../core/services/globals.service";
import * as i4 from "../../../core/services/utils.service";
import * as i5 from "@angular/common/http";
import * as i6 from "../../../core/services/ls-helper.service";
export class TransactionInvoiceService extends BaseProvider {
    constructor(authService, transactionService, globals, utils, http, ls) {
        super();
        this.authService = authService;
        this.transactionService = transactionService;
        this.globals = globals;
        this.utils = utils;
        this.http = http;
        this.ls = ls;
        this.costs = [];
        this.costQty = 1;
        this.subTotal = 0;
        this.total = 0;
        this.discountAmount = 0;
        this.selectedCosts = [];
        this.taxAmount = 0;
        this.costChange = new Subject();
        this.managementChange = new Subject();
        this.invoices = [];
        this.receipts = [];
        this.baseUrl = "userProcessInvoice";
        this.costChange.subscribe((cost) => {
            this.manageCost(cost);
            this.setInvoiceTotal();
        });
    }
    clearCosts() {
        this.costs.forEach((cost, index) => {
            cost.selected = false;
            cost.qty = 0;
        });
    }
    getInvoices(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/process/' + id;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.list = data.Data;
                console.log('list', this.list);
                this.invoices = this.list;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getPendingInvoices(processId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/userProcess/' + processId;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.pendingInvoicelist = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getCosts(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/process/' + id + '/cost';
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.costs = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    saveInvoice(invoiceId) {
        return new Promise((resolve, reject) => {
            let data = {
                TotalAmount: this.total ? this.total : 0,
                DiscountAmount: this.discountAmount ? this.discountAmount : 0,
                Costs: this.selectedCosts,
                InvoiceId: invoiceId ? invoiceId : 0,
                TaxAmount: this.taxAmount ? this.taxAmount : 0,
                Description: this.description
            };
            if (invoiceId > 0) {
                this.updateInvoice(data).then((data) => {
                    resolve(data);
                });
            }
            else {
                return this.createInvoice(data).then((data) => {
                    resolve(data);
                });
            }
        });
    }
    createInvoice(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl +
                `/process/${this.transactionService.itemToEdit.Id}/cost`;
            this.http
                .post(this.url, data)
                .subscribe((resp) => {
                resolve(resp);
            }, err => { reject(err); });
        });
    }
    updateInvoice(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl +
                `/process/${this.transactionService.itemToEdit.Id}` +
                `/cost/${data.InvoiceId}`;
            this.http
                .put(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    setInvoiceTotal() {
        this.subTotal = 0;
        this.selectedCosts.forEach((element, index) => {
            this.subTotal += (element.Amount * element.Qty);
        });
        this.total = this.subTotal;
        // this.taxAmount = (this.total *  0.04);
        this.total = this.total + this.taxAmount;
        this.setDiscount();
    }
    manageCost(obj) {
        let foundItem = this
            .utils
            .returnItemFromListByAttr(this.selectedCosts, "Id", obj.cost.Id);
        if (!this.utils.isEmpty(foundItem)) {
            this
                .utils
                .updateItemFromListByAttr(this.selectedCosts, "Id", Object.assign({}, obj.cost, { Qty: parseInt(obj.qty) }));
        }
        else {
            this.selectedCosts.push(Object.assign({}, obj.cost, { Qty: parseInt(obj.qty) }));
        }
    }
    removeCost(cost) {
        this
            .utils
            .removeItemFromListByAttr(this.selectedCosts, "Id", cost);
    }
    setDiscount() {
        if (this.discountAmount <= this.subTotal) {
            this.total = (this.subTotal - this.discountAmount) + this.taxAmount;
        }
    }
    canManage() {
        let canManage = false;
        if (!this.transactionService.itemToEdit.IsFinalized
            &&
                this.transactionService.itemToEdit.AssignedToCurrentUser
            &&
                this.authService.hasPolicy("CanCreateInvoices")) {
            canManage = true;
        }
        return canManage;
    }
    canCreateInvoice() {
        let canCreateInvoice = false;
        if (!this.transactionService.itemToEdit.IsFinalized
            &&
                this.transactionService.itemToEdit.AssignedToCurrentUser
            &&
                this.transactionService.itemToEdit.HasDynamicCostsForInvoice
            &&
                this.authService.hasPolicy("CanCreateInvoices")) {
            canCreateInvoice = true;
        }
        return canCreateInvoice;
    }
    canPayInvoice(invoice) {
        let canPay = false;
        if (this.transactionService.itemToEdit.Radicated
            &&
                !this.transactionService.itemToEdit.IsFinalized
            &&
                this.transactionService.itemToEdit.CreatedByCurrentUser == 1
            &&
                invoice.PaidDate == null) {
            canPay = true;
        }
        return canPay;
    }
    unpaidInvoiceCount() {
        let count = 0;
        this.list.forEach((invoice) => {
            count += (invoice.PaidDate == null) ? 1 : 0;
        });
        return count;
    }
    delete(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/additionalInvoice/" + params.Id;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getTotalAmountForInvoices(id) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl + this.baseUrl}/totalAmountForInvoices/process/${id}`;
            this.http.get(this.url).subscribe((data) => {
                resolve(data.Data);
            }, err => {
                reject(err);
            });
        });
    }
    saveCreditComment(data) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl + this.baseUrl}/payment/creditAllocation`;
            this.http.post(this.url, data).subscribe((data) => { resolve(data); }, err => { reject(err); });
        });
    }
}
TransactionInvoiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionInvoiceService_Factory() { return new TransactionInvoiceService(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.TransactionService), i0.ɵɵinject(i3.GlobalsService), i0.ɵɵinject(i4.UtilsService), i0.ɵɵinject(i5.HttpClient), i0.ɵɵinject(i6.LsHelperService)); }, token: TransactionInvoiceService, providedIn: "root" });
